import p5 from "p5";
import { GameController } from "../base/GameController";
import { View } from "./View";

export class ViewHello extends View {
    public constructor(protected p: p5, protected controller: GameController) {
        super();
    }

    public load() {
        document.addEventListener("keypress", this.on_keypress_func);
    }

    public unload() {
        document.removeEventListener("keypress", this.on_keypress_func);
    }

    public draw() {
        this.p.background(0);
        this.p.stroke(255);
        this.p.textSize(32);
        this.p.text("Welcome to the simple Number guesser", 100, 150);
        this.p.text("I will be thinking of a number", 100, 180);
        this.p.text("between 0 and 100.", 100, 210);
        this.p.text("You can guess wich number that is and", 100, 250);
        this.p.text("I will then respond if my number", 100, 280);
        this.p.text("is bigger or smaller.", 100, 310);

        this.p.text("Be careful though since", 100, 360);
        this.p.text("i will lie to you every 3rd time.", 100, 390);

        this.p.text("Press ENTER to start.", 100, 440);
    }

    private on_keypress_func = (event: KeyboardEvent): void => {
        if (event.key === "Enter") this.controller.new_number();
    };
}